export default {
  暂无此对象查看权限: 'No permission to view this object',
  '删除后该数据将不再可见，是否确认？': 'Delete after the data will no longer be visible, confirm?',
  确定并添加下一条: 'OK and add the next entry',
  确定并添加一条: 'OK and add the next entry',
  '关联记录单次新增数据条数最多100条！': 'The number of new data records can be added at most 100 times!'
};
